import React, {Component} from 'react';
import Icon from 'react-icons-kit';
import scrolling from './utils/animation/scrolling'

import './stylesheet/NavBar.css';

import {menu} from 'react-icons-kit/icomoon/menu';

class NavBar extends Component {
  mobileMenuToggle() {
    let narrowLinks = document.querySelector('.narrowLinks');
    if (narrowLinks.style.display === 'block') narrowLinks.style.display = 'none';
    else narrowLinks.style.display = 'block';
  }
  render() {
    return (
      <nav id="Navigation" className="nav">
        <div className="container">
          <ul className="menuWide">
            {this.props.menuItems.map( (item, i) => <li key={i} className="wideMenuItem">
              <a href={`#${item}`} onClick={scrolling}>{item}</a>
            </li> )}
          </ul>
          <div className="menuNarrow">
            <div className="menuButton" onClick={this.mobileMenuToggle}>
              <Icon size={32} icon={menu} />
              </div>
            <div className="narrowLinks">
              {this.props.menuItems.map( (item, i) => <a key={i} className="narrowMenuItem" href={`#${item}`} onClick={this.mobileMenuToggle}>{item}</a>)}
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar.js